module.exports = __webpack_public_path__ + "static/media/confirm_eval.4c149c78.png";